<template>
  <div class="section">
    <div class="container">
      <div class="columns is-multiline">
        <div class="column is-12">
          <h1 class="title is-1">Checkout</h1>
        </div>
        <div class="column is-12">
          <div class="columns is-multiline" v-show="!loading">
            <div class="column is-12">
              <div v-if="product === undefined" style="text-align:center">
                <i class="far fa-2x fa-spinner-third fa-spin"></i>
              </div>
            </div>
            <div class="column is-6">
              <div v-if="product != undefined && product.Id != 'Invalid Product'">
                <b-table :data="products">
                  <b-table-column field="name" label="Name" sortable v-slot="props">
                    <span>{{ props.row.name }}</span>
                    <p style="padding-left:5px; font-size:0.7em">{{ props.row.description }}</p>
                  </b-table-column>
                  <b-table-column field="amount" label="Amount" numeric sortable v-slot="props">
                    <span>${{ $math.format($math.round(props.row.amount.value, 2)) }}</span>
                  </b-table-column>
                </b-table>
              </div>
            </div>
            <div class="column is-6">
              <div v-if="cache != undefined && product != undefined && product.Id != 'Invalid Product' && products.length > 0">
                <paypal v-model="paypal" :products="products" :plan="cache.planId" @completing="loading = true" @complete="Complete" @ready="Ready"></paypal>
              </div>
            </div>
          </div>
          <div v-show="loading" style="text-align:center">
            <i class="far fa-spinner fa-pulse fa-2x"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        paypal: undefined,
        products: [],
        product: undefined,
        cache: {
          productId: undefined,
          updatesRole: undefined,
          planId: undefined,
          groupId: undefined,
          periodId: undefined
        },
        loading: false
      }
    },
    props: {
      productId: String,
      updatesRole: Boolean,
      planId: String,
      groupId: String,
      periodId: Number
    },
    methods: {
      CacheProps() {
        if (!this.cache || this.cache.productId === undefined) {
          this.cache = {
            productId: this.product.Id,
            updatesRole: this.updatesRole,
            planId: this.product.planId,
            groupId: this.groupId,
            periodId: this.periodId
          };
        }
        localStorage.setItem("Checkout", JSON.stringify(this.cache));
      },
      ClearCache() {
        localStorage.removeItem("Checkout");
      },
      GetCache() {
        var saved = localStorage.getItem("Checkout");
        if (saved !== undefined)
          this.cache = JSON.parse(saved);
      },
      Complete(details) {
        if (details.subscriptionID) {
          details.purchase_units = [{
            amount: this.products[0].amount,
            reference_id: this.products[0].reference_id
          }];
        }

        this.$http.post("api/payment", { details: details, extra: this.cache }).then(resp => {
          this.ClearCache();

          if (this.cache.updatesRole) { //Force a refresh of the JwtToken to see role-related changes
            var self = this;
            this.$http.post("api/user/refresh", { token: localStorage.getItem("CTC_REFRESH_TOKEN") }).then(async (resp) => {
              await self.$store.dispatch("refresh", resp.data);
              self.$router.push({ name: "thankyou" });
            }).catch(e => {
              self.$buefy.toast.open({
                duration: 10000,
                message: "Purchase successful, please check your email for further instrutions.",
                type: "is-success"
              });
              self.$store.dispatch('logout');
            });
          }
          else {
            this.$router.push({ name: "thankyou" });
          }
        });

      },
      Ready() {

      },
      GetProduct(Id) {
        this.$http.get("api/product/" + Id).then(resp => {
          this.product = resp.data;
          this.CacheProps();
          this.products.push({
            name: this.product.Name,
            description: this.product.Description,
            amount: {
              value: this.product.Price,
              currency_code: 'USD'
            },
            reference_id: this.product.Id,

            quantity: 1,
            sku: this.product.Id,
            category: 'DIGITAL_GOODS'
          });
        }).catch(err => {
          this.$buefy.notification.open({
            duration: 4000,
            message: "An error occurred getting product information. Please refresh and try again later.",
            type: 'is-danger',
            hasIcon: true
          });
        });
      }
    },
    created() {
      if (this.productId)
        this.GetProduct(this.productId);
      else {
        this.GetCache();
        if (this.cache == undefined) {
          this.$buefy.notification.open({
            duration: 0,
            message: "There is nothing in the cart.",
            type: 'is-danger',
            hasIcon: true
          });
          this.$router.go(-1);
        }
        else
          this.GetProduct(this.cache.productId);
      }
    },
    mounted() {

    }
  }
</script>
